import {
  PanelSection,
  PanelShortcut,
  PanelStat,
  SidebarGroup,
} from 'store/modules/ai_management_store/types';

export const SIDEBAR_GROUPS: SidebarGroup[] = [
  {
    key: 'ferramentas',
    label: 'Ferramentas gerais',
    items: [
      { key: 'painel', label: 'Painel', icon: 'dashboard' },
      { key: 'informacoes', label: 'Informações da licitação', icon: 'description' },
      { key: 'anotacoes', label: 'Anotações', icon: 'chat_bubble_outline' },
      { key: 'arquivos_edital', label: 'Arquivos do edital', icon: 'folder_open' },
      { key: 'tarefas', label: 'Tarefas', icon: 'assignment_turned_in' },
      { key: 'atualizacoes', label: 'Atualizações', icon: 'notifications' },
      {
        key: 'arquivos_licitante',
        label: 'Arquivos gerados pelo licitante',
        icon: 'insert_drive_file',
      },
    ],
  },
  {
    key: 'planejamento',
    label: 'Planejamento',
    items: [
      { key: 'analise_edital', label: 'Análise do Edital', icon: 'description' },
      { key: 'historico_contratacao', label: 'Histórico da Contratação', icon: 'history' },
      { key: 'possiveis_concorrentes', label: 'Possíveis Concorrentes', icon: 'people_outline' },
    ],
  },
  {
    key: 'participacao',
    label: 'Participação',
    items: [
      { key: 'preparar_documentacao', label: 'Preparar Habilitação', icon: 'description' },
      { key: 'elaborar_proposta', label: 'Preparar Proposta', icon: 'request_quote' },
      { key: 'mensagens_chat', label: 'Mensagens do chat', icon: 'forum' },
      { key: 'robo_lances', label: 'Cadastro de Proposta e Lances', icon: 'description' },
    ],
  },
  {
    key: 'pos_vendas',
    label: 'Pós-Vendas',
    items: [
      {
        key: 'analise_clausulas',
        label: 'Análise de Cláusulas Contratuais',
        icon: 'policy',
      },
    ],
  },
];

export const PANEL_STATS: PanelStat[] = [
  { key: 'anotacoes', icon: 'chat_bubble_outline', label: 'Anotações' },
  { key: 'tarefas', icon: 'assignment', label: 'Tarefas' },
  { key: 'atualizacoes', icon: 'notifications', label: 'Atualizações' },
  { key: 'chat', icon: 'forum', label: 'Mensagens do chat' },
];

export const PANEL_SHORTCUTS: PanelShortcut[] = [
  {
    icon: 'description',
    label: 'Informações da licitação',
    target: 'informacoes',
    linkLabel: 'Ver informações',
  },
  {
    icon: 'file_copy',
    label: 'Arquivos do edital',
    target: 'arquivos_edital',
    linkLabel: 'Ver arquivos',
    badge: 'Novo',
  },
];

export const PANEL_SECTIONS: PanelSection[] = [
  {
    key: 'anotacoes',
    icon: 'chat_bubble_outline',
    title: 'Últimas anotações',
    target: 'anotacoes',
    empty: 'Nenhuma anotação por aqui ainda.',
  },
  {
    key: 'atualizacoes',
    icon: 'notifications',
    title: 'Últimas atualizações',
    target: 'atualizacoes',
    empty: 'Nenhuma atualização por aqui ainda.',
  },
  {
    key: 'tarefas',
    icon: 'assignment',
    title: 'Próximas Tarefas',
    target: 'tarefas',
    empty: 'Nenhuma tarefa por aqui ainda.',
  },
  {
    key: 'chat',
    icon: 'forum',
    title: 'Últimas mensagens do chat',
    target: 'mensagens_chat',
    empty: 'Nenhuma mensagem por aqui ainda.',
  },
];
